import { render } from "./Recap.vue?vue&type=template&id=5fabb930&scoped=true"
import script from "./Recap.vue?vue&type=script&lang=js"
export * from "./Recap.vue?vue&type=script&lang=js"

import "./Recap.vue?vue&type=style&index=0&id=5fabb930&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fabb930"]])

export default __exports__